<template>
  <div>
    <b-form-group
      :label="
        $t('evaluations.newEvaluations.titleOf2', {
          entity: $getVisibleNames(
            'evaluations2.testdescriptor',
            false,
            'Descriptor'
          ),
        })
      "
      label-for="input-name"
      label-cols="0"
      label-cols-sm="3"
      label-cols-md="3"
      class="m-0 p-0"
    >
      <div
        class="descriptor-form-description mb-2"
        @click="
          $bvModal.show(
            `edit-test_descriptor-title-modal-${test_descriptor.id}`
          )
        "
        :class="{ 'warning-border': $v.test_descriptor.$anyError }"
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('evaluations.newEvaluations.editTitleOf', {
              entity: $getVisibleNames(
                'evaluations2.testdescriptor',
                false,
                'Descriptor'
              ),
            }),
            boundary: 'viewport',
          }"
          :content="test_descriptor.title"
        ></RenderVHtml>
      </div>
      <div v-if="$v.test_descriptor.$anyError" style="color: red">
        {{ $t("reusable.common.required") }}
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-test_descriptor-title-modal-${test_descriptor.id}`"
        :title_modal="
          $t('evaluations.newEvaluations.editTitleOf', {
            entity: $getVisibleNames(
              'evaluations2.testdescriptor',
              false,
              'Descriptor'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="test_descriptor"
        :content_rich_text="test_descriptor.title"
        :show_last_modification="true"
        @save="(content) => patchDescriptorTitle(test_descriptor, content)"
        @close="
          $bvModal.hide(
            `edit-test_descriptor-title-modal-${test_descriptor.id}`
          )
        "
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-test_descriptor-title-modal-${test_descriptor.id}`"
        :title="`Editar Título del ${$getVisibleNames(
          'evaluations2.testdescriptor',
          false,
          'Descriptor'
        )}`"
        size="lg"
        hide-footer
        ignore-enforce-focus-selector="#sidebar-right"
      >
        <NewRichTextEditor
          :Object="test_descriptor"
          :Text="test_descriptor.title"
          @save="patchDescriptorTitle"
          @close="
            $bvModal.hide(
              `edit-test_descriptor-title-modal-${test_descriptor.id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-name-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="
        $t('evaluations.newEvaluations.descriptionOf', {
          entity: $getVisibleNames(
            'evaluations2.testdescriptor',
            false,
            'Descriptor'
          ),
        })
      "
      label-for="input-description"
      label-cols="0"
      label-cols-sm="3"
      label-cols-md="3"
      class="m-0 p-0"
    >
      <div
        class="descriptor-form-description mb-2"
        @click="
          $bvModal.show(
            `edit-test_descriptor-description-modal-${test_descriptor.id}`
          )
        "
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('evaluations.newEvaluations.editDescriptionOf', {
              entity: $getVisibleNames(
                'evaluations2.testdescriptor',
                false,
                'Descriptor'
              ),
            }),
            boundary: 'viewport',
          }"
          :content="test_descriptor.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-test_descriptor-description-modal-${test_descriptor.id}`"
        :title_modal="
          $t('evaluations.newEvaluations.editDescriptionOf', {
            entity: $getVisibleNames(
              'evaluations2.testdescriptor',
              false,
              'Descriptor'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="test_descriptor"
        :content_rich_text="test_descriptor.description"
        :show_last_modification="true"
        :permit_blank="true"
        @save="
          (content) => patchDescriptorDescription(test_descriptor, content)
        "
        @close="
          $bvModal.hide(
            `edit-test_descriptor-description-modal-${test_descriptor.id}`
          )
        "
      >
        <template #content_up>
          <!-- Acordion para mostrar los IL -->
          <div
            v-if="
              institution &&
              institution.internal_use_id == 'duoc_uc' &&
              (transversalFormat ||
                formativeFormat ||
                partialFormatEEP ||
                partialFormatWrite)
            "
            class="accordion"
            role="tablist"
          >
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 mx-2" role="tab">
                <b-button block v-b-toggle.accordion-1 variant="info">
                  {{
                    $t("curricularProducts.competence.noRaBaseMessage", {
                      entity1: $getVisibleNames(
                        "teaching.evaluationcriteriamicro",
                        true,
                        "Criterios de Evaluación Micro"
                      ),
                      entity2: $getVisibleNames(
                        "evaluations2.test",
                        false,
                        "Instrumento"
                      ),
                    })
                  }}
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                :visible="false"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body class="card-body-il">
                  <template v-for="ecm in evaluationCriteriaMicro">
                    <ul :key="ecm.id" class="mx-0 px-0">
                      <li>
                        {{ ecm.full_sentence }}
                      </li>
                    </ul>
                    <!-- <SentenceContainer
                        :unique_id="'ecm-from-descriptor' + ecm.id"
                        :Sentence="ecm"
                        :boundedTextContainer="false"
                        :showColorCognitiveLevel="true"
                        :showCognitiveLevel="true"
                      ></SentenceContainer> -->
                  </template>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </template>
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-test_descriptor-description-modal-${test_descriptor.id}`"
        :title="`Editar Descripción del ${$getVisibleNames(
          'evaluations2.testdescriptor',
          false,
          'Descriptor'
        )}`"
        size="xl"
        hide-footer
        ignore-enforce-focus-selector="#sidebar-right"
      > -->
      <!-- Acordion para mostrar los IL -->
      <!-- <div
          v-if="
            institution &&
            institution.internal_use_id == 'duoc.cl' &&
            (transversalFormat ||
              formativeFormat ||
              partialFormatEEP ||
              partialFormatWrite)
          "
          class="accordion"
          role="tablist"
        >
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 mx-2" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="info">
                {{
                  $getVisibleNames(
                    "teaching.evaluationcriteriamicro",
                    true,
                    "Criterios de Evaluación Micro"
                  )
                }}
                de la
                {{
                  $getVisibleNames("evaluations2.test", false, "Instrumento")
                }}
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              :visible="false"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body class="card-body-il">
                <template v-for="ecm in evaluationCriteriaMicro">
                  <ul :key="ecm.id" class="mx-0 px-0">
                    <li>
                      {{ ecm.full_sentence }}
                    </li>
                  </ul> -->
      <!-- <SentenceContainer
                        :unique_id="'ecm-from-descriptor' + ecm.id"
                        :Sentence="ecm"
                        :boundedTextContainer="false"
                        :showColorCognitiveLevel="true"
                        :showCognitiveLevel="true"
                      ></SentenceContainer> -->
      <!-- </template>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
        <NewRichTextEditor
          :Object="test_descriptor"
          :Text="test_descriptor.description"
          :permit_blank="true"
          @save="patchDescriptorDescription"
          @close="
            $bvModal.hide(
              `edit-test_descriptor-description-modal-${test_descriptor.id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-description-feedback">{{
        $t("reusable.common.optional")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <!-- Visible para Estudiantes -->
    <b-form-group
      label-for="input-visible-evaluatees"
      label-cols="0"
      label-cols-sm="3"
      label-cols-md="3"
      class="m-0 p-0"
    >
      <template #label>
        <div class="block-title-container">
          <div>
            {{ $t("evaluations.newEvaluations.showToEvaluatees") }}
          </div>
          <div class="ml-2">
            <InfoTooltip
              :tooltip_text="
                $t('evaluations.newEvaluations.ifThisOptionIsSelectedContent')
              "
            ></InfoTooltip>
          </div>
        </div>
      </template>
      <b-form-checkbox
        class="mt-2"
        v-model="test_descriptor.visible_by_evaluatees"
        size="md"
      >
      </b-form-checkbox>
    </b-form-group>
    <b-form-group
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="test_descriptor"></ModificationDate>
    </b-form-group>
    <div class="col" style="text-align: right">
      <b-button class="mr-1" size="sm" @click="saveTestDescription">
        {{ $t("reusable.common.save") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId, toast } from "@/utils/utils";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TestDescriptorForm",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    // SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    test_id: {
      type: Number,
      required: true,
    },
    position_number: {
      type: Number,
      required: true,
    },
    order: {
      type: Number,
    },
    testDescriptor: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          title: "",
          description: "",
          order: this.order,
          test: this.test_id,
          position: this.position_number,
          visible_by_evaluatees: true,
          creation_date: null,
          created_by: null,
          updated_by: null,
          update_date: null,
        };
      },
    },
    evaluation_situations: {
      type: Array,
    },
    evaluation_criteria_micro_ids: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      test_descriptor: { ...this.testDescriptor },
    };
  },
  validations: {
    test_descriptor: {
      title: { required },
      description: {},
    },
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
      tests: names.NEW_TESTS,
      evaluations: names.NEW_EVALUATIONS,
    }),
    test() {
      return this.tests.find((x) => x.id == this.test_id);
    },
    evaluation() {
      return this.evaluations.find((x) => x.id == this.test.evaluation);
    },
    evaluationCriteriaMicro() {
      return this.evaluation_criteria_micros.filter((x) =>
        this.evaluation_criteria_micro_ids.includes(x.id)
      );
    },
    transversalFormat() {
      return (
        this.evaluation &&
        this.evaluation.type == 4 &&
        this.evaluation_situations &&
        this.evaluation_situations.some((x) =>
          [
            "duoc_prueba_escrita_preguntas_abiertas_test",
            "duoc_prueba_seleccion_multiple_test",
            "duoc_ejecucion_practica_test",
            "duoc_entrega_de_encargo_test",
            "duoc_presentacion_test",
          ].includes(x.internal_use_id)
        )
      );
    },
    formativeFormat() {
      return this.evaluation && this.evaluation.type == 3;
    },
    partialFormatEEP() {
      return (
        this.evaluation &&
        this.evaluation.type == 1 &&
        this.evaluation_situations &&
        this.evaluation_situations.some((x) =>
          [
            "duoc_ejecucion_practica_test",
            "duoc_entrega_de_encargo_test",
            "duoc_presentacion_test",
          ].includes(x.internal_use_id)
        )
      );
    },
    partialFormatWrite() {
      return (
        this.evaluation &&
        this.evaluation.type == 1 &&
        this.evaluation_situations &&
        this.evaluation_situations.some((x) =>
          ["duoc_prueba_escrita_preguntas_abiertas_test"].includes(
            x.internal_use_id
          )
        )
      );
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.test_descriptor[name];
      return $dirty ? !$error : null;
    },
    patchDescriptorTitle(object, text) {
      this.test_descriptor.title = text;
    },
    patchDescriptorDescription(object, text) {
      this.test_descriptor.description = text;
    },
    saveTestDescription() {
      this.$v.test_descriptor.$touch();
      if (this.$v.test_descriptor.$anyError) {
        return;
      }
      if (isNaN(this.test_descriptor.id)) this.createTestDescriptor();
      else this.updateTestDescriptor();
    },
    createTestDescriptor() {
      this.$store
        .dispatch(names.POST_NEW_TEST_DESCRIPTOR, this.test_descriptor)
        .then((response) => {
          this.test_descriptor = response;
          toast(
            this.$getVisibleNames(
              "evaluations2.testdescriptor",
              false,
              "Descriptor"
            ) +
              " " +
              this.$t("reusable.common.created")
          );
          this.$emit("closeModal");
        });
    },
    updateTestDescriptor() {
      this.$store
        .dispatch(names.UPDATE_NEW_TEST_DESCRIPTOR, this.test_descriptor)
        .then((response) => {
          this.test_descriptor = response;
          toast(
            this.$getVisibleNames(
              "evaluations2.testdescriptor",
              false,
              "Descriptor"
            ) +
              " " +
              this.$t("reusable.common.updated")
          );
          this.$emit("closeModal");
        });
    },
  },
  created() {},
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.card-body-il {
  max-height: 210px;
  overflow-y: auto;
}
.block-title-container {
  display: flex;
  justify-content: space-between;
}
.descriptor-form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.descriptor-form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.warning-border {
  border: 1px solid #dc3545 !important;
  color: red;
}
</style>

